import React from 'react'

export default function Top_heading(props) {
  window.scrollTo(0, 0);
  return (
    <>
   <div className="mainone">
  
   <div className="main-heading14">
      <div className="mainTitle">
        <h1>{props.Heading}</h1>
      </div>
      <div className="mainDesc">
      <p>{props.para} </p>
      </div>
    </div>
    </div>

      
    </>
  )
}
